var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 30,
    viewBox: "0 0 47 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(-742.375 -407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M46.06,2.518H0V-5H46.06Z",
    transform: "translate(742.845 412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M47,2.518H0V-5H47Z",
    transform: "translate(742.375 423.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M23.307,2.518H0V-5H23.307Z",
    transform: "translate(765.599 434.482)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.594ad13da0ff2d9d4f9ea1c4f0305728.svg";
export { ForwardRef as ReactComponent };